export default __webpack_public_path__ + "svg/d604708109b6e57d4ef5120c8a241755.svg";